import React from 'react';
import parse from 'html-react-parser';
import Link from '../utils/link';
import {Logo} from './icons';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const ThankYou = ({title, content, image}) => (
  <section className="thank-you">
    <GatsbyImage image={getImage(image?.localFile)} alt={image.altText} />

    <div className="thank-you__logo">
      <Link to="/" title="Kervale">
        <Logo color={`#FFFFFF`}/>
      </Link>
    </div>

    <div className="thank-you__inner">
      <div className="thank-you__wrapper">
        <h1>{title}</h1>

        <p>{parse(content)}</p>

        <div className="thank-you__btn">
          <Link className="btn btn--blue" to="/">HOME</Link>
          <Link className="btn btn--outline" to="/">PREVIOUS PAGE</Link>
        </div>
      </div>
    </div>
  </section>
);

ThankYou.defaultProps = {
  title: ``,
  content: ``,
  image: ``,
};

export default ThankYou;